<template>
  <div class="container-fluid companyInfoPage">
    <div class="col companyInfoSection container">
      <h1 class="col-12">Producent podłóg drewnianych – MAD Dawid Maćkowiak</h1>
      <div class="col-12">
        <div class="container-fluid mainContent">
          <div class="textContent container col-xl-7">
            <h3 v-scrollanimation>
              MANUFAKTURA. ORYGINALNOŚĆ. DOŚWIADCZENIE. INDYWIDUALIZM.
              CHARAKTER. STYL.
            </h3>
            <p v-scrollanimation v-html="text"></p>
          </div>
          <div class="imgContainer col-12 col-sm-10 col-md-8 col-lg-5">
            <b-img :src="logo" fluid alt="Fluid image"></b-img>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text:
        "Ręcznie wykańczane podłogi dębowe to nasza specjalność od lat. Dziesiątki wzorów w połączeniu z indywidualnym podejściem do każdego zamówienia to pewność niepowtarzalności i oryginalnego stylu. Nasza firma już od wielu lat profesjonalnie zajmuje się dostarczaniem Państwu naturalnych i w pełni funkcjonalnych desek do domu i na taras, które w miarę upływu czasu nie tylko nie tracą swoich właściwości i walorów estetycznych, ale wręcz zyskują na swojej atrakcyjności. Jako profesjonalny producent podłóg drewnianych możemy zapewnić, że nasze klepki są w stanie zadowolić nawet najbardziej wymagającego Klienta, który poszukuje rozwiązań, mogących bez problemu przetrwać&nbsppróbę&nbspczasu.",
      logo: require("../../assets/common/logo.png")
    };
  }
};
</script>
<style scoped>
.companyInfoPage {
  background-color: #eee;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.companyInfoSection {
  display: flex;
  background-color: #eee;
  color: #000;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 2% 10%;
}
.mainContent {
  background-color: #fff;
  display: flex;
  padding: 5% 4%;
  margin-left: 0%;
  margin-right: 0%;
  flex-direction: row;
  align-items: center;
}

.textContent {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
}
.imgContainer {
  display: flex;
  justify-content: center;
  padding: 2% 0%;
  max-height: 20rem;
  max-width: 32rem;
}

@media (min-width: 1808px) {
  h3 {
    margin-bottom: 6%;
  }
}
@media (min-width: 1200px) {
  .imgContainer {
    padding: 5% 0%;
  }
}
@media (min-width: 1450px) {
  .imgContainer {
    padding: 2% 0%;
  }
}
@media (max-width: 1200px) {
  .mainContent {
    flex-direction: column;
  }
}
@media (max-width: 600px) {
  .companyInfoSection {
    padding: 0% 0%;
  }
  h1 {
    margin-top: 5%;
  }
}
</style>
